<template>
  <div>
    <div v-if="form">
      <div>
        <p><b>Timing</b></p>
        <date-time v-model="form.data.meeting.fields.timing.value" :date="form.data.meeting.fields.timing.value"></date-time>
      </div>
      <div>
        <p><b>History Company</b></p>
        <history-companies-search-box v-model="form.data.meeting.fields.history_company_id.value" :selected_history_company_name="selected_history_company_name">
        </history-companies-search-box>
      </div>
      <div>
        <p><b>Applicant Message</b></p>
        <textarea v-model="form.data.meeting.fields.applicant_message.value" placeholder="Applicant Message"></textarea>
      </div>
      <div>
        <p><b>Company Message</b></p>
        <textarea v-model="form.data.meeting.fields.company_message.value" placeholder="Company Message"></textarea>
      </div>
      <div>
        <checkbox v-model="form.data.meeting.fields.requested_interview_preparation.value" :checked="form.data.meeting.fields.requested_interview_preparation.value">
          Requested Interview Preperation
        </checkbox>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import HistoryCompaniesSearchBox from '@/components/HistoryCompaniesSearchBox'
import Checkbox from '@/components/Checkbox'
import DateTime from '@/components/DateTime'
export default {
  name: 'admin-meetings-form',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      form: undefined,
      selected_history_company_name: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        return
      }
      this.$network_utils.getMeeting({ meeting_id: this.payload.data.id }).then(response => {
        this.selected_history_company_name = response.history_company.name
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        meeting: {
          fields: {
            timing: {
              value: form_data.timing,
              has_error: false,
              validations: []
            },
            history_company_id: {
              value: form_data.history_company_id,
              has_error: false,
              validations: []
            },
            applicant_message: {
              value: form_data.applicant_message,
              has_error: false,
              validations: []
            },
            company_message: {
              value: form_data.company_message,
              has_error: false,
              validations: []
            },
            requested_interview_preparation: {
              value: form_data.requested_interview_preparation,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/meetings/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  },
  components: {
    HistoryCompaniesSearchBox,
    Checkbox,
    DateTime
  }
}
</script>
